import React from 'react';
import { Typography } from '@mui/material';
import { LineChart } from '@mui/x-charts/LineChart';
import { WidgetCard, WidgetEmptyState } from './WidgetCard';

const TrendLineWidget = ({ widget, metric }) => {
  const series = Array.isArray(metric?.series) ? metric.series : [];
  const showLegend = Boolean(widget.params?.showLegend);
  if (!series.length) {
    return (
      <WidgetCard
        title={widget.params?.title || 'Trend'}
        subtitle={widget.params?.metricId}
        testId={`report-widget-${widget.id || widget.params?.metricId || 'trend-line'}`}
      >
        <WidgetEmptyState message="Trend data is not available yet." />
      </WidgetCard>
    );
  }
  const labels = series.map((point) => point.x);
  const values = series.map((point) => point.y);
  return (
    <WidgetCard
      title={widget.params?.title || 'Trend'}
      subtitle={widget.params?.metricId}
      testId={`report-widget-${widget.id || widget.params?.metricId || 'trend-line'}`}
    >
      <LineChart
        height={220}
        xAxis={[{ data: labels, scaleType: 'point' }]}
        series={[{ data: values, label: widget.params?.title || widget.params?.metricId || 'Trend' }]}
        legend={{ hidden: !showLegend }}
      />
      <Typography variant="caption" color="text.secondary">
        Updated with latest query results.
      </Typography>
    </WidgetCard>
  );
};

export default TrendLineWidget;
